import { Approval } from '@/models/approval';

export class State {
    public allApprovals: Array<Approval> = new Array<Approval>();
    public allApprovalsPageNumber: number = 1;
    public allApprovalsPageSize: number = 25;
    public allApprovalsTotalPages: number = 1;
    public allApprovalsTotal: number = 0;
    public allApprovalsFilterStatus: number | string | null = '';
    public allApprovalsFrom: string | null = null;
    public allApprovalsTo: string | null = null;
}
